<template>
  <header class="main-header">
    <router-link
      :to="{ name: 'Home' }"
      class="logo"
    >
      <img
        src="../../../img/demis-digital-white.png"
        alt="Demis digial"
      >
    </router-link>

    <a
      ref="sidebarToggle"
      href="#"
      class="sidebar-toggle"
      data-toggle="push-menu"
      role="button"
    >
      <span class="sr-only">Меню</span>
    </a>

    <img
      src="../../../img/navbar-toggle.png"
      class="navbar-toggle-custom"
      alt="navbar"
      @click="navbarToggle()"
    >

    <nav
      class="navbar navbar-static-top"
      :style="{ display: navbarShow === null ? undefined : (navbarShow ? 'block' : 'none') }"
    >
      <!-- Sidebar toggle button-->
      <a
        href="#"
        class="sidebar-toggle"
        data-toggle="push-menu"
        role="button"
      >
        <span class="sr-only">Меню</span>
      </a>
      <!-- Navbar Right Menu -->
      <div class="navbar-custom-menu">
        <ul class="nav navbar-nav">
          <li v-if="isSeoServiceConnected">
            <form class="navbar-form">
              <button
                class="btn background-white text-danger"
                type="button"
                data-toggle="modal"
                :data-target="'#' + $getConst('FORM_SOS_MODAL_ID')"
              >
                {{ condensedHeaderStage1 ? 'SOS' : 'Нужна срочная помощь!' }}
              </button>
            </form>
          </li>
          <li v-if="isSeoServiceConnected">
            <a
              href="#"
              class="text-warning site-access-request-btn"
              data-toggle="modal"
              :data-target="'#' + $getConst('FORM_ACCESS_MODAL_ID')"
            ><i class="fa fa-unlock-alt" /> {{ condensedHeaderStage1 ? '' : 'Получить доступы к сайту' }}</a>
          </li>
          <li v-if="managerInfoIsLoaded">
            <div class="manager-info">
              <a
                v-if="managerInfo.photo"
                href="#"
                data-toggle="modal"
                :data-target="'#' + $getConst('FORM_MAIL_ORDER_MODAL_ID')"
                class="manager-photo"
                :style="{ 'background-image': `url(${managerInfo.photo})` }"
                title="Написать письмо менеджеру"
              />
              <span
                v-if="!condensedHeaderStage2"
                class="text-muted"
              >Ваш {{ managerMainOrNotText }} менеджер</span><br>
              <span
                v-if="!condensedHeaderStage2"
                class="manager-name"
              >{{ managerInfo.name }}</span> <a
                v-if="!condensedHeaderStage2"
                href="#"
                data-toggle="modal"
                :data-target="'#' + $getConst('FORM_MAIL_ORDER_MODAL_ID')"
                title="Написать письмо менеджеру"
              ><i class="fa fa-envelope-o" /></a>
            </div>
          </li>
          <li v-if="!condensedHeaderStage2 && managerInfoIsLoaded && managerInfo.innerPhone">
            <a
              :href="'tel:' + managerInfo.innerPhone"
              class="manager-phone-container"
            >
              <span class="manager-phone">{{ managerInfo.innerPhone }}</span><template v-if="managerInfoAddPhonesText"> доб. {{ managerInfoAddPhonesText }}</template>
            </a>
          </li>
          <li v-if="isSeoServiceConnected">
            <form class="navbar-form">
              <button
                class="btn background-white text-danger"
                type="button"
                data-toggle="modal"
                :data-target="'#' + $getConst('FORM_CALL_ORDER_MODAL_ID')"
              >
                <i
                  v-if="condensedHeaderStage1"
                  class="fa fa-phone"
                  aria-hidden="true"
                />
                <span v-else>Заказать звонок</span>
              </button>
            </form>
          </li>
          <client-switcher />
          <!-- Старый выбор домена клиента скрыт в impersonation-режиме (его заменяет client-switcher) -->
          <template v-if="clientDomainsCount && !impersonated">
            <li
              v-if="clientDomainsCount > 1"
              class="dropdown domain-select-container"
            >
              <a
                href="#"
                class="dropdown-toggle"
                data-toggle="dropdown"
                role="button"
                aria-haspopup="true"
                aria-expanded="false"
              >{{ clientDomainsSelected }} <span class="caret" /></a>
              <ul class="dropdown-menu">
                <li
                  v-for="domain in clientDomainsWithoutSelected"
                  :key="domain"
                >
                  <a
                    href="#"
                    @click.prevent="changeClientDomainSelected(domain)"
                  >{{ domain }}</a>
                </li>
              </ul>
            </li>
            <li
              v-else
              class="domain-select-container"
            >
              <div class="navbar-text">
                {{ clientDomainsSelected }}
              </div>
            </li>
          </template>
          <li class="logout-container">
            <a
              href="#"
              @click.prevent="logout"
            ><img
              src="../../../img/logout.png"
              alt="logout"
            ></a>
          </li>
          <li v-if="Object.keys($store.state.seo.projects.projects).length">
            <form class="navbar-form">
              <button
                class="btn background-white text-danger"
                type="button"
                data-toggle="modal"
                data-target="#select-client"
              >
                Клиент
              </button>
            </form>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { setAuthRedirectUrlCookie } from '../../helper'
import grid from '../../mixins/grid'
import ClientSwitcher from './ClientSwitcher.vue'

/**
 * Хэдер.
 */
export default {
  name: 'CHeader',
  components: { ClientSwitcher },
  mixins: [grid],
  data () {
    return {
      navbarShow: null
    }
  },
  computed: {
    /**
     * Соответствует ли текущая ширина окна диапазону в котором нужно уменьшить элементы меню хедера, но не все.
     */
    condensedHeaderStage1 () {
      return this.gridSm && this.initialInnerWidth < 1600
    },
    /**
     * Соответствует ли текущая ширина окна диапазону в котором нужно уменьшить все элементы меню хедера.
     */
    condensedHeaderStage2 () {
      return this.gridSm && this.initialInnerWidth < 1230
    },
    isSeoServiceConnected () {
      return this.isServiceConnected(this.$getConst('SERVICE_SEO'))
    },
    ...mapGetters({
      managerMainOrNotText: 'manager/mainOrNotText',
      clientDomainsWithoutSelected: 'seo/client/domains/withoutSelected',
      clientDomainsCount: 'seo/client/domains/count',
      managerInfoAddPhonesText: 'manager/addPhonesText',
      managerInfoIsLoaded: 'manager/isLoaded',
      isServiceConnected: 'services/isConnected'
    }),
    ...mapState({
      managerInfo: state => state.manager.manager,
      clientDomainsSelected: state => state.seo.client.domains.selected,
      impersonated: state => state.impersonation.active
    })
  },
  created () {
    this.initialInnerWidth = window.innerWidth
  },
  mounted () {
    this.$root.$on('sidebarRouteNavigation', this.handleSidebarRouteNavigation)
  },
  destroyed () {
    this.$root.$off('sidebarRouteNavigation', this.handleSidebarRouteNavigation)
  },
  methods: {
    /**
     * Разлогинивает пользователя.
     */
    logout () {
      // deprecated
      localStorage.removeItem('selectedClientId') // TODO: перенести в SEO-модуль

      localStorage.removeItem('impersonationClientLogin')
      setAuthRedirectUrlCookie()
      window.location = '/api/client/logout'
    },
    /**
     * Показывает/скрывает меню в хедере.
     */
    navbarToggle () {
      this.navbarShow = !this.navbarShow
    },
    /**
     * Скрывает сайдбар после навигации через меню сайдбара на мобильной версии.
     */
    handleSidebarRouteNavigation () {
      const toggle = this.$refs.sidebarToggle

      if (window.getComputedStyle(toggle).getPropertyValue('display') !== 'none') {
        toggle.click()
      }
    },
    ...mapActions({
      changeClientDomainSelected: 'seo/client/domains/changeSelected'
    })
  }
}
</script>

<style lang="scss" scoped>
@import "./resources/css/_variables.scss";

.manager-info {
  padding: 5px 15px;

  @media (max-width: $menuCondensedStage2Breakpoint) {
    padding-left: $menuCondensedPaddingX;
    padding-right: $menuCondensedPaddingX;
  }

  .manager-photo {
    float: left;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 10px;
    background-size: cover;

    @media (max-width: $menuCondensedStage2Breakpoint) {
      margin-right: 0;
    }
  }
}

.manager-phone-container {
  @media (max-width: $xsBreakpoint) {
    text-align: center;
  }

  .manager-phone {
    font-weight: bold;
  }
}

.manager-info .manager-name,
.site-access-request-btn {
  @media (max-width: $xsBreakpoint) {
    text-align: center;
  }

  .fa-unlock-alt {
    padding-right: 3px;
  }
}

@media (max-width: $xsBreakpoint) {
  .domain-select-container {
    float: left !important;
  }

  .logout-container {
    float: right !important;
  }
}
</style>
